import React from 'react'
import TagCloud from 'react3dtagcloud'

// 文献图谱-搜索词词云
export default function LiteratureMap() {
  const tagName = [ 'Lung', 'Mucus', 'Humans', 'Mice', 'Lung Neoplasms', 'Bronchitis', 'Pulmonary Emphysema', 'Respiratory Insufficiency', 'Heart Diseases', 'Metabolic Syndrome', 'Acute Disease', 'Disease Progression', 'Inflammation', 'Carbon Monoxide', 'Pancreatic Elastase', 'Biomarkers', 'Bronchodilator Agents', 'Tomography, X-Ray Computed', 'X-Ray Microtomography', 'Forced Expiratory Volume', 'Prognosis', 'Molecular Targeted Therapy', 'Respiration, Artificial', 'Oxygen Inhalation Therapy', 'Pneumonectomy', 'Disease Models, Animal', 'Smokin', 'Cognition', 'Cognition Disorders', 'Mitophagy', 'Genotype', 'Phenotype', 'Oxidative Stress', 'Precision Medicine', 'Electronic Nicotine Delivery Systems', 'History, 19th Century', 'History, 20th Century', 'Terminology as Topic', 'Disease Management', 'Comorbidity', 'Severity of Illness Index', 'Risk', 'Risk Factors', 'Health Status', 'Incidence' ]
  return(
    <div style={{ width: '60%' }}>
      <TagCloud tagName={ tagName } radius={150}/>
    </div>
    
  )
}
